

import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { Control, useFormContext } from 'react-hook-form';
import { ProfileFormValues } from '../ProfileFormSchema';
import { useSubscription } from '@/hooks/subscription';

interface EmailPreferencesFieldProps {
  control: Control<ProfileFormValues>;
}

export function EmailPreferencesField({ control }: EmailPreferencesFieldProps) {
  const { isSubscribed } = useSubscription();
  const { setValue } = useFormContext<ProfileFormValues>();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Email Preferences</h3>
      <FormField
        control={control}
        name="email_preferences.weekly_summary"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Weekly Training Summary</FormLabel>
              <FormDescription>
                Receive a weekly {isSubscribed ? 'insight' : 'summary'} of your training activities {isSubscribed && '(premium)'}
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={(checked: boolean) => {
                  field.onChange(checked);
                  // Since we're combining both toggles, we need to sync them
                  setValue('email_preferences.weekly_insights', checked);
                }}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
